import { render } from "./Add.vue?vue&type=template&id=208226aa"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=208226aa&lang=css"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__